var map = {
	"./pr-1.png": "90db",
	"./pr-10.png": "268a",
	"./pr-11.png": "27b1",
	"./pr-2.png": "0c95",
	"./pr-3.png": "2e97",
	"./pr-4.png": "f63e",
	"./pr-5.png": "e023",
	"./pr-6.png": "4ca5",
	"./pr-7.png": "6447",
	"./pr-8.png": "2a0e",
	"./pr-9.png": "5b21"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3b90";